import { GlobalState } from '../../actions';

const hsdEditSelector = (state: GlobalState) => state.hsdEdit;

export const hsdEditEntitySelector = (state: GlobalState) => hsdEditSelector(state).hsd;
export const hsdEditUgNameSelector = (state: GlobalState) => hsdEditSelector(state).ugName;
export const hsdEditAvailableEntitiesSelector = (state: GlobalState) =>
    hsdEditSelector(state).availableStandardDescriptors;
